document.addEventListener('DOMContentLoaded', () => {
  const searchOverlayTriggers = Array.from(document.getElementsByClassName('js-search-toggle'));

  searchOverlayTriggers.forEach((current) => {
    current.addEventListener('click', () => {
      // Create a new event
      const event = new CustomEvent('searchToggle');
      // Dispatch the event
      document.dispatchEvent(event);
    });
  });
});
